import { isWebticsError, setupWebtics, webticsCall } from "@anna-money/webtics";

export function gaSendUserEvent(eventName: string, eventValue: Nullable<string> = null): void {
  if (window.ga) {
    window.ga("send", "event", "user", eventName, eventValue);
  }
}

export const invoiceLinkAnalyticsEvents = {
  screen: "invoice-link-screen",
  pay: "invoice-link-click-pay",
  downloadInvoicePdf: "invoice-link-click-download-invoice-pdf",
  downloadReceiptPdf: "invoice-link-click-download-receipt-pdf",
  refreshPage: "invoice-link-click-refresh-page",
  documentStorage: "invoice-link-click-document-storage",
  footerVariation: "invoice-link-footer-variation",
  footerVariationActivation: "invoice-link-footer-variation-activated",
};

export const gaEventName = {
  clickConnectByTrueLayer: "click pay by banks",
  clickConnectByStripe: "click pay by card",
  clickFaq: "click faq",
  clickStartAcceptPayments: "click start accepting payments",
};

export interface IAnalyticsManager {
  event: (eventType: string, payload: Record<string, unknown>) => Promise<void>;
}

export class AnalyticsManager implements IAnalyticsManager {
  constructor(apiUrl: string, webticsTrackerUrl: string) {
    setupWebtics(
      webticsTrackerUrl,
      { apiUrl, appName: "payme", consentMode: "transient" },
      {
        errorHandler: (e) => {
          if (!isWebticsError(e, "network")) {
            console.error(e);
          }
        },
      },
    );
  }

  async event(eventType: string, payload: Record<string, unknown>): Promise<void> {
    webticsCall("event", eventType, payload);
  }
}
